import { createContext } from 'react';

export type ChatWorkspaceReservation = {
  side: 'left' | 'right';
  width: number;
} | null;

export const ChatWorkspaceContext = createContext<{
  reserve: (reservation: ChatWorkspaceReservation) => void;
}>({ reserve: () => undefined });
